// extracted by mini-css-extract-plugin
module.exports = {"container":"Guarantee_container__1OwKO","title":"Guarantee_title__3HoxN","background":"Guarantee_background__2Ri4w","block":"Guarantee_block__3qoY0","img":"Guarantee_img__YY9xh"};